import ScrollItem from './ScrollItem'
import SmoothItem from './SmoothItem'
import ParallaxItem from './ParallaxItem'
import SmoothScrollManager from './'

export default class ScrollItems {
  scrollItems: ScrollItem[] = []
  smoothItems: SmoothItem[] = []
  parallaxItems: ParallaxItem[] = []

  constructor(public scrollManager: SmoothScrollManager) {}

  init(): void {
    const elmScrollItems = document.querySelectorAll('.js-scroll-item')
    const elmSmoothItems =
      document.querySelectorAll<HTMLDivElement>('.js-smooth-item')
    const elmParallaxItems =
      document.querySelectorAll<HTMLDivElement>('.js-parallax-item')

    this.scrollItems = []
    this.smoothItems = []
    this.parallaxItems = []

    for (let i = 0; i < elmScrollItems.length; i++) {
      this.scrollItems[i] = new ScrollItem(elmScrollItems[i])
    }
    for (let i = 0; i < elmSmoothItems.length; i++) {
      this.smoothItems[i] = new SmoothItem(
        elmSmoothItems[i],
        this.scrollManager,
        this.scrollManager.hookes.smooth,
        elmSmoothItems[i].dataset
      )
    }
    for (let i = 0; i < elmParallaxItems.length; i++) {
      this.parallaxItems[i] = new ParallaxItem(
        elmParallaxItems[i],
        this.scrollManager,
        this.scrollManager.hookes.parallax,
        elmParallaxItems[i].dataset
      )
    }
  }

  scroll(): void {
    for (let i = 0; i < this.scrollItems.length; i++) {
      this.scrollItems[i].show(
        this.scrollManager.scrollTop + this.scrollManager.resolution.y,
        this.scrollManager.scrollTop
      )
    }
  }

  resize(): void {
    for (let i = 0; i < this.scrollItems.length; i++) {
      this.scrollItems[i].init(this.scrollManager.scrollTop)
    }
    for (let i = 0; i < this.smoothItems.length; i++) {
      this.smoothItems[i].init(this.scrollManager.scrollTop)
    }
    for (let i = 0; i < this.parallaxItems.length; i++) {
      this.parallaxItems[i].init(this.scrollManager.scrollTop)
    }
  }

  render(isWorking: boolean): void {
    for (let i = 0; i < this.smoothItems.length; i++) {
      this.smoothItems[i].render(isWorking)
    }
    for (let i = 0; i < this.parallaxItems.length; i++) {
      this.parallaxItems[i].render(isWorking)
    }
  }
}
